import { AcrylicDemo5, AcrylicEffect, AcrylicEffect2, AcrylicEffect3, AcrylicEffectStyle } from "..\\..\\..\\..\\content\\studio\\fluent-ui\\acrylic\\acrylic-ui-example.tsx";
import React from 'react';
export default {
  AcrylicDemo5,
  AcrylicEffect,
  AcrylicEffect2,
  AcrylicEffect3,
  AcrylicEffectStyle,
  React
};